import { reactive, ref, computed, watch, watchEffect } from '@vue/composition-api'
import store from '@/store'
import * as common from '@/util/common'
import { WEB_WINDOW_PRINT_DATA_NAME } from '@/util/constants'

/**
 * 関連情報ウィンドウ
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    from: computed(() => {
      return store.state.qaRelatedInfo.from
    }),

    relatedInfoTarget: computed(() => {
      return store.state.qaRelatedInfo.target
    }),
    relatedInfoKey: computed(() => {
      return store.state.qaRelatedInfo.key
    }),
    relatedInfoTitle: computed(() => {
      return store.state.qaRelatedInfo.title
    }),

    // 前のページのチャンクNo
    preChunkNumber: computed(() => {
      return store.state.qaRelatedInfo.wljpPreChunkNumber
    }),

    // 次のページのチャンクNo
    nextChunkNumber: computed(() => {
      return store.state.qaRelatedInfo.wljpNextChunkNumber
    }),

    visiblePrevPageButton: computed(() => {
      return (group1.wljpDataType === 'detail' && group1.preChunkNumber !== 0)
    }),
    visibleNextPageButton: computed(() => {
      return (group1.wljpDataType === 'detail' && group1.nextChunkNumber !== 0)
    }),

    // 戻る / 前へ / 次へ のいずれかのボタンが表示可能か
    isAnyButtonDisplayed: computed(() => {
      return (group1.visiblePrevPageButton || group1.visibleNextPageButton || group1.historyCount > 0)
    }),

    // 履歴の数
    historyCount: computed(() => {
      return store.state.qaRelatedInfo.histories.length
    }),

    // ### 内容現在関係データ ###
    // 内容現在欄外の日付情報文言
    current_contents_message: computed(() => {
      return store.state.qaRelatedInfo.current_contents_message
    }),
    current_contents_messageDisp: computed(() => {
      let value = group1.current_contents_message
      value = value.replace(/<br>/g, '\n')
      value = value.replace(/<br\/>/g, '\n')
      value = value.replace(/<br.*?>/g, '\n')
      value = common.escapeHTML(value)
      return value.replace(/\r?\n/g, '<br>')
    }),
    // 内容現在リスト
    current_contents_list: computed(() => {
      return store.state.qaRelatedInfo.current_contents_list
    }),

    // ### WLJ連携関係データ ###

    // WLJPコンテンツのデータタイプ(list=一覧画面、detail=詳細画面)
    wljpDataType: computed(() => {
      return store.state.qaRelatedInfo.wljpDataType
    }),

    // WLJPコンテンツの内容(HTML)
    wljpContent: computed(() => {
      return store.state.qaRelatedInfo.wljpContent
    }),
    // WLJPコンテンツのURLリンク
    wljpLink: computed(() => {
      return store.state.qaRelatedInfo.wljpLink
    }),
    // WLJPコンテンツのURLリンクフラグ
    wljpLinkFlag: computed(() => {
      return store.state.qaRelatedInfo.wljpLinkFlag
    }),
    // WLJPコンテンツのリスト(HTML)
    wljpList: computed(() => {
      return store.state.qaRelatedInfo.wljpList
    }),

    // 内容現在データロード完了フラグ
    isCurrentContentsLoaded: computed(() => {
      return store.state.qaRelatedInfo.isCurrentContentsLoaded
    }),
    // WLJPコンテンツデータロード完了フラグ
    isWLJPContentsLoaded: computed(() => {
      return store.state.qaRelatedInfo.isWLJPContentsLoaded
    }),

    /**
     * 履歴を１つ戻す
     */
    goBackInHistory: () => {
      store.dispatch('qaRelatedInfo/goBackInHistory')
    },

    /**
     * チャンクNoを指定したページ遷移
     * @param {number} chunkNumber チャンクNo
     */
    goToPageByChunkNumber: (chunkNumber) => {
      store.dispatch('qaRelatedInfo/goToPageByChunkNumber', { chunkNumber })
    },

    /**
     * リンク先にアクセス
     */
    access: (relatedInfoTarget, relatedInfoKey, relatedInfoTitle) => {

      // 起動元(current_contents=内容現在、related_info=関連情報)
      const from = store.state.qaRelatedInfo.from

      if (relatedInfoTarget === 'LG-007') {
        // LG-007=新旧対照表の場合は、新旧対照表ウィンドウを表示する
        store.dispatch('qaRelatedInfo/setVisibleRelatedData', false)
        store.dispatch('qaRelatedInfo/setVisibleOldAndNewMappings', true)
      } else {
        // それ以外の場合は、関連情報ウィンドウを表示する
        store.dispatch('qaRelatedInfo/setVisibleRelatedData', true)
        store.dispatch('qaRelatedInfo/setVisibleOldAndNewMappings', false)
      }

      store.dispatch('qaRelatedInfo/setValues', { from: from, target: relatedInfoTarget, key: relatedInfoKey, title: relatedInfoTitle })

      // 表示用データをロードする
      const chunkNumber = 0
      store.dispatch('qaRelatedInfo/loadWLJPContents', { chunkNumber })
    },

    /**
     * 新旧対照表をブラウザの別ウィンドウで開く
     */
    openQAOldAndNewMappings: (relatedInfoTarget, relatedInfoKey, relatedInfoTitle) => {

      // トークン（別ウィンドウで表示する印刷画面のトークン認証で使用）
      const token = store.state.auth.token

      // QAタイトル
      const qaTitle = store.state.qaRelatedInfo.qaTitle

      const printData = {
        title: qaTitle,
        api_params: {
          target: relatedInfoTarget,
          key: relatedInfoKey
        }
      }

      try {
        const printJSON = JSON.stringify(printData)  
        // ローカルストレージ経由でパラメータを渡す
        localStorage.setItem(WEB_WINDOW_PRINT_DATA_NAME, printJSON)
  
        // 印刷用ウィンドウを別ウィンドウで開く
        window.open('/lc/app/pc/window/qa-old-and-new-mappings-window?token=' + token, '_blank')

      } catch (e) {
      }
    }
    
  })

  return group1
}
